if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        let responseStatus='';
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.log(response.status);
              responseStatus=response.status;
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
             $.ajax({
                    url: '/',
                    type: "GET",
                    dataType: "html",
                    success: function(data) {
                      $('.cart-icon').html($(data).find('.cart-icon').html());
                      $('.account-icon-container').html($(data).find('.account-icon-container').html());
              
                      $('.main_icon_header_wrap').html($(data).find('.main_icon_header_wrap').html());
                      $('.checkout_button_custom').html($(data).find('.checkout_button_custom').html());
              $(".cart-count-bubble").removeClass('hide');
                      var check_length = $(".cart-items .cart-item.cart-item").length;
              if(check_length == 0){
                  $('body').addClass('empty_cart');
                  }else{
                  $('body').removeClass('empty_cart');
              }
              
              const cartPopup = document.querySelector('.cart-popup');
              cartPopup.classList.add('active');
              setTimeout(() => {
              cartPopup.classList.remove('active');
              
              }, 1500);
              const cartIcon2 = document.querySelector('#cart-icon-bubble');
              const cartPopup2 = document.querySelector('.cart-popup');
              
              // Show the popup on mouse enter
              cartIcon2.addEventListener('mouseenter', () => {
              cartPopup2.classList.add("active");
              });
              
              // Hide the popup when leaving the popup area
              cartPopup2.addEventListener('mouseleave', () => {
              cartPopup2.classList.remove("active");
              });
              
                    },
                  });
              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
               this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {

              $.ajax({
                    url: '/cart',
                    type: "GET",
                    dataType: "html",
                    success: function(data) {
                      console.log(data);
                      $('.cart-icon').html($(data).find('.cart-icon').html());
                      $('.account-icon-container').html($(data).find('.account-icon-container').html());
              
                      $('.main_icon_header_wrap').html($(data).find('.main_icon_header_wrap').html());
                      $('.checkout_button_custom').html($(data).find('.checkout_button_custom').html());
              $(".cart-count-bubble").removeClass('hide');
                      var check_length = $(".cart-items .cart-item.cart-item").length;
              /** Code to update the shipping rule cart attribute **/        
              if($('#shipping_rule',data).val() != undefined){
                fetch("/cart/update.js", {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify({
                attributes: {
                "Shipping Rule": $('#shipping_rule',data).val(),
                },
                }),
                })
                .then((response) => {
                if (!response.ok) {
                throw new Error("Network response was not ok");
                }
                return response.json();
                })
                .then((data) => {
                console.log("Shipping Rule updated in cart attributes:", data);
                })
                .catch((error) => {
                console.error("Error updating cart attributes:", error);
                });
              }
              /** Code to update the shipping rule cart attribute end here**/           
              if(check_length == 0){
                  $('body').addClass('empty_cart');
                  }else{
                  $('body').removeClass('empty_cart');
              }
              
              const cartPopup = document.querySelector('.cart-popup');
              cartPopup.classList.add('active');
              setTimeout(() => {
              cartPopup.classList.remove('active');
              
              }, 1500);
              const cartIcon2 = document.querySelector('#cart-icon-bubble');
              const cartPopup2 = document.querySelector('.cart-popup');
              
              // Show the popup on mouse enter
              cartIcon2.addEventListener('mouseenter', () => {
              cartPopup2.classList.add("active");
              });
              
              // Hide the popup when leaving the popup area
              cartPopup2.addEventListener('mouseleave', () => {
              cartPopup2.classList.remove("active");
              });
              
                    },
                  });
              
              
              // Add a small delay to allow hovering over the popup
                 //     this.cart.renderContents(response);
                    }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled'); 
            console.log("responseStatus=="+responseStatus);
          
             if (responseStatus!=422) {
             this.submitButton.classList.add('loading-sucess');
               this.submitButton.querySelector('.has-success').style.display = 'flex';
              var this_submitButton =this.submitButton;
              setTimeout(function(){
                this_submitButton.classList.remove('loading-sucess');
                this_submitButton.querySelector('.has-success').style.display = 'none';
              },2000);
             }
              this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
         this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
         // var get_text = $(".product-form__submit").html();

        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          const existingIcon = this.submitButton.querySelector('.icon');
          const existinghasSuccess = this.submitButton.querySelector('.has-success');
        if (!existingIcon) {
          this.submitButton.insertAdjacentHTML('beforeend', '<i class="icon icon-cart-icon"></i>');
      }
           if (!existinghasSuccess) {
              this.submitButton.querySelector('.icon-cart-icon').insertAdjacentHTML('beforebegin', '  <span class="has-success" style="display: none;"><i class="fa fa-check" style="position: static;"></i> Success</span>');
           }
       //$(".product-form__submit").html(get_text);
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
